var map = {
	"./account.svg": 42116,
	"./alertEdit.svg": 51135,
	"./alertIcon.svg": 4764,
	"./applyIcon.svg": 85118,
	"./arrowDown.svg": 76546,
	"./arrowLeft.svg": 99369,
	"./arrowRight.svg": 53716,
	"./arrowUp.svg": 51281,
	"./chartIcon.svg": 15262,
	"./checkBox.svg": 96656,
	"./closeBtn.svg": 81939,
	"./closeIcon.svg": 64566,
	"./closeViaOEBtn.svg": 17293,
	"./delayIcon.svg": 99835,
	"./heatmapIcon.svg": 19670,
	"./infoIcon.svg": 49960,
	"./invisibleData.svg": 50128,
	"./linkOrderOnChart.svg": 29694,
	"./linkedAccounts.svg": 32284,
	"./minus.svg": 80757,
	"./moreIcon.svg": 15843,
	"./orderOnChart.svg": 10794,
	"./overnight.svg": 60333,
	"./placeBtn.svg": 94148,
	"./plus.svg": 37399,
	"./positionOnChartIcon.svg": 4352,
	"./scaleSelectorAbsolute.svg": 96711,
	"./scaleSelectorLog.svg": 48486,
	"./scaleSelectorRelative.svg": 83168,
	"./sellAssetBtn.svg": 47947,
	"./settingsBtn.svg": 88200,
	"./showOnChartBtn.svg": 80971,
	"./sortDown.svg": 19555,
	"./sortUp.svg": 34140,
	"./threeDotsMenu.svg": 4720,
	"./toBeginBtn.svg": 86473,
	"./trailingBtn.svg": 46413,
	"./userGroup.svg": 69655,
	"./visibleData.svg": 80323,
	"./zoomInBtn.svg": 66869,
	"./zoomOutBtn.svg": 73478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38648;